module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.totalItems > 10) ? _c('div', [_c('div', {
    staticClass: "ls-pagination-filter"
  }, [_c('div', {
    staticClass: "ls-filter-view"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('application.pagination.display')) + "\n      "), _c('div', {
    staticClass: "ls-custom-select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perPage),
      expression: "perPage"
    }],
    staticClass: "ls-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.perPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changePerPage()
      }]
    }
  }, _vm._l((_vm.selectValues), function(selectValue) {
    return _c('option', {
      domProps: {
        "value": selectValue
      }
    }, [_vm._v("\n            " + _vm._s(selectValue) + "\n          ")])
  }))]), _vm._v("\n      " + _vm._s(_vm.$t('application.pagination.items_per_page')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "total-items"
  }, [_c('div', [_vm._v(_vm._s(_vm.$root.plural(_vm.totalItems, 'application.pagination.found_items')))])]), _vm._v(" "), (_vm.totalItems > 0) ? _c('div', {
    staticClass: "pages"
  }, [_c('paginate', {
    attrs: {
      "page-count": _vm.totalPages,
      "forcePage": _vm.currentPage - 1,
      "initial-page": _vm.currentPage - 1,
      "page-range": 3,
      "margin-pages": 1,
      "click-handler": _vm.callBack,
      "prev-text": _vm.$t('application.pagination.previous'),
      "next-text": _vm.$t('application.pagination.next'),
      "container-class": 'pagination',
      "page-class": 'page-item'
    }
  })], 1) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47ab411c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/shareds/pagination/Pagination.vue
// module id = 769
// module chunks = 1